import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const RouteScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export default RouteScrollReset;
